var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2068",
    "data-name": "Grupo 2068",
    transform: "translate(-655 -1010)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_396",
    "data-name": "Caminho 396",
    d: "M281,296H231a15,15,0,0,1-15-15V231a15,15,0,0,1,15-15h50a15,15,0,0,1,15,15v50A15,15,0,0,1,281,296Z",
    transform: "translate(439 794)",
    fill: "#fef9f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2025",
    "data-name": "Grupo 2025",
    transform: "translate(674.883 1028.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3342",
    "data-name": "Caminho 3342",
    d: "M112.29,51.851a78.725,78.725,0,0,1,7.157,6.232c7-7.076,14.007-9.887,15.285-16.146.94-4.605-2.037-9.379-6.663-9.893-3.51-.389-7.3,1.593-8.623,4.559-1.326-2.967-5.114-4.949-8.623-4.559-4.626.513-7.6,5.289-6.663,9.893.547,2.679,2.144,4.726,4.339,6.746",
    transform: "translate(-95.501 -31.995)",
    fill: "#fcdea4",
    stroke: "#fcdea4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3340",
    "data-name": "Caminho 3340",
    d: "M176,229.889v-3.865s2.9-2.174,2.9-4.831V218.61",
    transform: "translate(-158.818 -196.072)",
    fill: "none",
    stroke: "#b8882a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3341",
    "data-name": "Caminho 3341",
    d: "M93.57,156.492s6.243-5.951,8.023-7.73,4.2,2.179,2.079,4.831c-1.042,1.042-2.079,1.932-2.079,1.932v1.932a4.8,4.8,0,0,1-4.011,4.831",
    transform: "translate(-86.343 -134.269)",
    fill: "#fffbf5",
    stroke: "#b8882a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1747",
    "data-name": "Ret\\xE2ngulo 1747",
    width: 20,
    height: 9,
    transform: "translate(0.117 32.752)",
    fill: "none",
    stroke: "#b8882a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_42",
    "data-name": "Linha 42",
    x2: 1,
    transform: "translate(4.117 37.752)",
    fill: "none",
    stroke: "#fcdea4",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3343",
    "data-name": "Caminho 3343",
    d: "M69.917,135.46l-3.984,3.157C64.566,139.869,64,140.584,64,142.482v14.3",
    transform: "translate(-60.345 -122.964)",
    fill: "none",
    stroke: "#b8882a",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card1.bfd516462d2981bca35868b747bdc2c0.svg";
export { ForwardRef as ReactComponent };